import { type ReactNode } from "react";
import {
  Sheet,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";

// Right-side slide-over used by user/node detail views. Built on the shadcn
// Sheet (Radix Dialog); keeps the original imperative open/onClose API. Focus
// trap, Escape, and scroll-lock are handled by Radix.
export function Drawer({
  open,
  onClose,
  title,
  children,
  footer,
}: {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <Sheet open={open} onOpenChange={(o) => !o && onClose()}>
      <SheetContent aria-describedby={undefined}>
        <SheetHeader>
          <SheetTitle className="truncate pr-8">{title}</SheetTitle>
        </SheetHeader>
        <div className="scrollbar-thin flex-1 overflow-y-auto px-5 py-5">
          {children}
        </div>
        {footer && <SheetFooter>{footer}</SheetFooter>}
      </SheetContent>
    </Sheet>
  );
}
